import { hasCapability, type User } from "../base";

export const bidContact = {
  read: (user: User) => hasCapability(user, "bidContact.read"),
};
